<!-- 静态数据table -->
<template>
    <el-dialog custom-class="OrderPre-Dialog-Pay OrderPre-Dialog container" :destroy-on-close="true" :append-to-body="true"
        title="" :visible.sync="staticPayShow">
        <el-table :header-cell-style="{
            backgroundColor: '#FDEFE7', color: '#000000'
        }" v-loading="loading" border :data="tableData" style="width: 100%;height: 600px">
            <el-table-column align="center" prop="date" label="子订单号" width="230">
                <template slot-scope="scope">
                    <div class="tableLine1">
                        <div class="btns1">{{ scope.row.stateName }}</div>
                        <p class="p1">平台操作记录</p>
                    </div>
                    <p class="p2">{{ scope.row.orderChildrenId }}</p>
                    <p class="p3">{{ scope.row.resourceName ? scope.row.resourceName : scope.row.resourceNameEn }}</p>
                    <!-- <p class="p4">库存供应商:{{ scope.row.stockCompanyId }}</p> -->
                    <p class="p5">{{ scope.row.stockCompanyName }}</p>
                    <div style="display: flex;align-items: center;justify-content: center;"
                        v-if="scope.row.associatedListMap">
                        <!-- <el-button
                          @click="similarProductsClick(scope.row.associatedListMap, Object.keys(scope.row.associatedListMap)[0])"
                          type="primary" size="mini" class="btns2">{{ btnMap[Object.keys(scope.row.associatedListMap)[0]]
                          }}</el-button> -->
                        <span @click="similarProductsClick(scope.row.associatedListMap, n)"
                            v-for="(n, m) in Object.keys(scope.row.associatedListMap)" :key="m" class="btns2">{{ btnMap[n]
                            }} <i class="el-icon-arrow-right" style="font-weight: bold;"></i> </span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column width="400" align="center" prop="name" label="商品">
                <template slot-scope="scope">
                    <div class="tableLine2" v-for="(item, index) in scope.row.orderListDetailResultList" :key="index">
                        <p class="p1">
                            <span class="span1">{{ item.number }} {{ item.priceCompany }}</span>
                            <span class="span2">{{ item.productName }}</span>

                        </p>
                        <p class="p1">
                            <span class="span2" v-if="item.stockId != 0" style="font-weight: 400;color: #333333;">{{
                                item.stockId
                            }} </span>
                        </p>
                        <p class="p1" style="margin-bottom: 0;">
                            <span class="span1">{{ item.number }} {{ item.priceCompany }}</span>
                            <span class="span4" v-if="item.startTime == item.endTime">{{ item.startTime }}</span>
                            <span class="span4" v-else>{{ item.startTime + "-" + item.endTime }}</span>
                        </p>
                        <p class="p3">
                            <!-- [标准价] 早餐2份 果盘一份 3晚 3间 入住当天23:00前免费取消 -->
                        </p>
                        <!-- <div v-if="index != scope.row.orderListDetailResultList.length - 1" class="line"></div> -->
                    </div>
                </template>
            </el-table-column>
            <el-table-column align="center" prop="address" width="180" label="单元（元）*数量 *汇率 ">
                <template slot-scope="scope">
                    <div class="tableLine3" v-for="(item, index) in scope.row.orderListDetailResultList" :key="index">
                        <p class="p1">{{ item.currency }}{{ item.price }}/{{ item.priceCompany }}<span
                                v-if="item.useTime">/</span> {{
                                    item.useTime
                                }}</p>
                        <p class="p2">{{ item.number + item.priceCompany }} {{
                            days(item.startTime, item.endTime, scope.row.state) + 1
                        }}{{
    item.useTime ? item.useTime : '天'
}}</p>
                        <p class="p3" v-if="item.rate != 1">
                            <span style="color:  #5F6266;"> 汇率：{{ item.rate }} </span>
                            <!-- <span style="color: #5F6266;">{{ item.totalPrice}}</span><span class="span1">¥</span> -->
                        </p>
                        <p v-if="item.cancelNumber > 0" class="lp4">已取消的数量：{{ item.cancelNumber }}</p>
                        <!-- <div v-if="index != scope.row.orderListDetailResultList.length - 1" class="line"></div> -->
                    </div>
                </template>
            </el-table-column>
            <el-table-column align="center" prop="name" label="商品总价（元）" width="180">
                <template slot-scope="scope">
                    <div class="tableLine4">
                        <p class="p1" style="margin-bottom: 0;">{{ totalPrice(scope.row.orderListDetailResultList) }}￥</p>
                        <p v-if="dataType == 1">利润：<span style="color: red;">{{
                            profitPrice(scope.row.orderListDetailResultList)
                        }}¥</span></p>
                        <!-- <p>-30.00</p>
                        <p>满300减20</p>
                        <p>满600减10</p> -->
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <div class="footer">
            <div style="display: flex;align-items: center;justify-content: flex-end;">
                <p style="color: red;margin-right: 0.2rem;">子订单无法单独付款，一起下订单的产品需要一起付款！！！</p>
                <p>总计：<span style="color: #d81b43;font-weight: 700">{{ payPrice() }} ¥</span></p>
            </div>
            <el-button @click="payment"
                style="margin-top: 15px;width: 100px;color: rgb(255, 255, 255);background-color: rgb(222, 86, 44);border-color: rgb(222, 86, 44);">付款</el-button>
            <Pay routeData="?currentComponent=sonOrder" @payUpload="payUpload" ref="Pay"
                :dataMap="{ totalPrice: payPrice() }" :payMoney="Number(payPrice())"
                :orderChildrenIds="tableData.map(u => u.orderChildrenId)" :orderMainId="orderMainId"></Pay>
        </div>
    </el-dialog>
</template>

<script>
import closeBookPopup from "./closeBookPopup.vue";
import bookState from "./bookState.vue";
import Pay from "@/components/ThirdPay/Pay.vue";
import similarProductsPopup from "./similarProductsPopup.vue";
import { days, sortByCreateTime } from '@/assets/utils/unit'
import OrderApi from "../../../../../components/Api/order";
import { OrderMinxin } from "@/views/mechanism/components/myDealChild/sonOrderMinxin";

export default {
    props: {
        dataType: {
            default: 0
        },
        isOperation: {
            type: Boolean,
            default: true
        },
        operationWidth: {
            type: Number,
            default: 550
        }
    },
    components: {
        closeBookPopup,
        bookState,
        Pay,
        similarProductsPopup
    },
    data() {
        return {
            days,
            btnMap: {
                'INSUFFICIENT_QUANTITY_AND_TIME': '时间数量已有变化',
                'SIMILAR_PRODUCTS': '已有类似商品'
            },
            staticPayShow: false,
            tableData: [],
            loading: true,
            orderMainId: ''
        };
    },
    // mixins: [OrderMinxin],
    computed: {
        //计算总价钱
        totalPrice() {
            return function (arr) {
                let price = 0
                arr.forEach(n => {
                    price += n.price * n.number * n.rate * (this.days(n.startTime, n.endTime) + 1)
                });
                return price.toFixed(4)
            }
        },
        //总利润
        profitPrice() {
            return function (arr) {
                let price = 0
                arr.forEach(n => {
                    price += n.profitPrice
                });
                return price.toFixed(4)
            }
        },

        payPrice() {
            return function () {
                let price = 0
                this.tableData.forEach(item => {
                    price = Number(price) + Number(this.totalPrice(item.orderListDetailResultList))
                })
                console.log("price",price)
                //return parseFloat(price.toFixed(5)).toFixed(2)
                return this.keepTwoDecimalFull(price)
            }
        }
    },
    watch: {},
    methods: {
        keepTwoDecimalFull(num) {
                var result = parseFloat(num);
                if (isNaN(result)) {
                    alert('传递参数错误，请检查！');
                    return false;
                }
                result = Math.round(num * 100) / 100;
                var s_x = result.toString(); //将数字转换为字符串
                var pos_decimal = s_x.indexOf('.'); //小数点的索引值
                // 当整数时，pos_decimal=-1 自动补0
                if (pos_decimal < 0) {
                    pos_decimal = s_x.length;
                    s_x += '.';
                }
                // 当数字的长度< 小数点索引+2时，补0
                while (s_x.length <= pos_decimal + 2) {
                    s_x += '0';
                }
                return s_x;
            },
        payUpload() {
            this.staticPayShow = false
        },
        payment() {
            console.log("payment", this.$refs)
            this.$refs.Pay.init();
        },
        init(orderMainId) {
            this.orderMainId = orderMainId
            let pageRequest = {
                page: 1,
                size: 10000,
                q: {
                    orderMainId: orderMainId
                }
            }
            new OrderApi('order').platOrderList(pageRequest).then(res => {
                if (res.status == 200) {
                    console.log(res.data.records,'时刻打开时空的');
                    
                    this.tableData = res.data.records.filter(n => n.status === "1A1A1A")
                    this.staticPayShow = true
                    this.loading = false
                } else {
                    this.$message.error({ message: res.statusText })
                }
            })
        }
    },
    created() {
    },
    mounted() {
    },
};
</script>
<style>
.OrderPre-Dialog-Pay {
    width: 990px;
    position: absolute;
    top: -70px;
}

.OrderPre-Dialog-Pay .el-dialog__body {
    flex-direction: column;
}

.OrderPre-Dialog-Pay .el-table--border {
    border-radius: 16px;
}
</style>
<style lang="scss" scoped>
/deep/ .el-table th {
    color: black;
}

.container {
    width: 100%;

    .tableLine1 {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 0.05rem;

        .p1 {
            color: #006FFF;
            font-size: 0.12rem;
            font-family: SourceHanSansSC-regular;
        }

        .btns1 {
            width: 40px;
            height: 20px;
            line-height: 20px;
            border-radius: 8px;
            background-color: #DE562C;
            color: rgba(255, 255, 255, 1);
            font-size: 0.12rem;
            text-align: center;
            font-family: PingFang SC;
            margin-right: 0.12rem;
        }


    }

    .btns2 {
        display: flex;
        align-items: center;
        padding: 1px 3px;
        border-radius: 3px;
        background-color: rgba(230, 74, 25, 1);
        text-align: center;
        color: rgba(255, 255, 255, 1);
        font-size: 12px;
        font-family: PingFangSC-regular;
        transform: scale(0.8);
        transform-origin: 0px 0px;
        cursor: pointer;
    }

    .p2 {
        color: #5F6266;
        font-size: 0.12rem;
        font-family: SourceHanSansSC-regular;
        margin-bottom: 0.05rem;
    }

    .p3 {
        color: #006FFF;
        font-size: 0.12rem;
        // font-weight: bold;
        margin-bottom: 0.05rem;
        font-family: SourceHanSansSC-bold;
    }

    .p4 {
        color: #d81b43;
        font-size: 0.12rem;
        font-family: SourceHanSansSC-bold;
        margin-bottom: 0.05rem;
    }

    .p5 {
        color: #d81b43;
        font-size: 0.12rem;
        font-family: SourceHanSansSC-bold;
        overflow: hidden; //超出的文本隐藏
        text-overflow: ellipsis; //溢出用省略号显示
        white-space: nowrap; //溢出不换行
        margin-bottom: 0.05rem;
    }

    .tableLine2 {
        text-align: left;
        border-top: 1px solid #dbdbdb;
        display: flex;
        justify-content: center;
        flex-direction: column;

        &:nth-child(1) {
            border: none;
        }

        .p1 {
            margin-bottom: 0.05rem;

            .span1 {
                color: rgba(216, 27, 67, 1);
                font-size: 0.12rem;
                font-family: SourceHanSansSC-bold;
                font-weight: bold;
                margin-right: 0.1rem;

            }

            .span2 {
                margin-right: 0.1rem;
                color: #333333;
                font-size: 0.12rem;
                font-family: SourceHanSansSC-bold;
                font-weight: bold;
                cursor: pointer;

                &:hover {
                    text-decoration: underline;
                }
            }

            .span4 {
                color: #5F6266;
                font-size: 0.12rem;
                font-weight: bold;
                margin-right: 0.1rem;
                font-family: SourceHanSansSC-bold;
            }
        }

        .line {
            border-bottom: 1px solid #dbdbdb;
            margin: 0.06rem 0;
        }
    }

    .tableLine3 {
        text-align: left;
        height: 1rem;
        border-top: 1px solid #dbdbdb;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        &:nth-child(1) {
            border: none;
        }

        .p1 {
            color: #FF0000;
            font-size: 0.12rem;
            font-weight: bold;
            font-family: SourceHanSansSC-bold;
            margin-bottom: 0.05rem;
            text-decoration: underline;
        }

        .p3 {
            .span1 {
                color: #FF0000;
                font-size: 0.12rem;
                font-family: SourceHanSansSC-bold;
                font-weight: bold;
            }
        }

        .lp4 {
            font-size: 0.12rem;
            font-weight: bold;
            color: #DCA550;
        }

        .line {
            border-bottom: 1px solid #dbdbdb;
            margin: 0.06rem 0;
        }
    }

    .tableLine4 {
        .p1 {
            color: rgba(216, 27, 67, 1);
            font-size: 0.12rem;
            font-family: SourceHanSansSC-bold;
            font-weight: bold;
        }

        p {
            margin-bottom: 0.05rem;
        }
    }

    .footer {
        width: 935px;
        text-align: right;
        position: relative;
        height: 100px;
        top: 21px;
    }
}
</style>
